import { render } from "./MyExpansionItem.vue?vue&type=template&id=6f15ab1e&ts=true"
import script from "./MyExpansionItem.vue?vue&type=script&lang=ts"
export * from "./MyExpansionItem.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jib/PWA/test-couleur-vue3-quasar/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
